import i18next from 'i18next';

import { exportFile } from 'common/api/v1/contacts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import { SET_IS_DOWNLOADING } from '../actionTypes';
import { contactActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(contactActions[SET_IS_DOWNLOADING](true));
    exportFile()
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `${i18next.t('Contact', { count: 2 })}.csv`,
            );
            document.body.appendChild(link);
            link.click();
            dispatch(contactActions[SET_IS_DOWNLOADING](false));
        })
        .catch((error) => {
            dispatch(contactActions[SET_IS_DOWNLOADING](false));
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
